import { FC } from 'react';
import { CashAccountFormValues } from '..';
import { PercentageInput } from '../../UI';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';

interface CashAccountOwnershipAllocationInputProps {
  className?: string;
}

export const CashAccountOwnershipAllocationInput: FC<CashAccountOwnershipAllocationInputProps> = ({ className }) => {
  const { t: tForm } = useTranslation('form');
  const { control } = useFormContext<CashAccountFormValues>();
  const {
    field,
    formState: { errors },
  } = useController<CashAccountFormValues, 'ownershipAllocation'>({
    control,
    name: 'ownershipAllocation',
    rules: { required: true, min: 0 },
    defaultValue: 100,
  });

  return (
    <PercentageInput
      {...field}
      decimalsLimit={3}
      allowNegativeValue={false}
      className={className}
      placeholder={tForm('general-required-placeholder')}
      label={tForm('general-ownership-allocation-input')}
      status={errors.ownershipAllocation ? 'errored' : 'normal'}
    />
  );
};
